<!--
  File name: AssignUserDropdown.vue
  Program Description:
    - This component allows entries in the dropdown field to load
    the items depending on the visible area to lessen initial loading
    times for dropdown fields with multiple items
    - It shows the assigned items for the Evaluator and Reviewers fields
-->
<template>
  <v-autocomplete
    v-model="modelValue"
    :items="items"
    :label="label"
    :rules="rules"
    :disabled="!canEdit"
    :item-text="itemText"
    :item-value="itemValue"
    :menu-props="{ maxWidth: '400' }"
    dense
    outlined
    clearable
  >
    <template #item="{ item }">
      <v-menu
        offset-x
        open-on-hover
        max-width="400"
        :nudge-width="200"
        :disabled="item.totalDbnsAssigned === 0"
      >
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on">
            <v-list-item-content>
              <v-list-item-title>{{ item[itemText] }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-avatar
                color="#A01A1A"
                size="35"
                class="white--text"
              >
                {{ item.totalDbnsAssigned }}
              </v-avatar>
            </v-list-item-avatar>
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-list-item>
        </template>
        <v-virtual-scroll
          :items="item.assignedDbns"
          item-height="100"
          height="300"
          style="background-color: white;"
        >
          <template v-slot:default="dbns">
            <v-list-item class="text-center">
              <v-list-item-title
                class="font-weight-bold"
              >
                DBN No.
              </v-list-item-title>
              <v-list-item-title>{{ dbns.item.dbnNumber }}</v-list-item-title>
            </v-list-item>
            <v-list-item class="text-center">
              <v-list-item-title
                class="font-weight-bold"
              >
                Status
              </v-list-item-title>
              <v-list-item-title>
                <StatusChip
                  :status="dbns.item.dbnStatus"
                />
              </v-list-item-title>
            </v-list-item>
            <v-divider />
          </template>
        </v-virtual-scroll>
      </v-menu>
    </template>
  </v-autocomplete>
</template>

<script>
import StatusChip from '@/components/StatusChip'
export default {
  name: 'SelectHoverMenu',
  components: { StatusChip },
  props: {
    value: {
      type: String,
      default: ''
    },
    itemText: {
      type: String,
      default: 'fullName'
    },
    itemValue: {
      type: String,
      default: '_id'
    },
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        return this.$emit('input', val)
      }
    }
  }
}
</script>
